import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from './auth/role.guard';
import { AuthGuard } from './auth/auth.guard';
import { HomeComponent } from './home/home.component';
import { CampanaComponent } from './home/campana/campana.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { EjeComponent } from './home/eje/eje.component';
import { TipologiaComponent } from './home/tipologia/tipologia.component';
import { EntrevistaComponent } from './home/entrevista/entrevista.component';
import { DistribuidorComponent } from './home/distribuidor/distribuidor.component';
import { RolComponent } from './home/rol/rol.component';
import { AgenteComponent } from './home/agente/agente.component';
import { AsignarCampanaComponent } from './home/asignar-campana/asignar-campana.component';
import { RazonAlarmaComponent } from './home/razon-alarma/razon-alarma.component';
import { SupervisorComponent } from './supervisor/supervisor.component';
import { MonitorcampanasComponent } from './supervisor/monitorcampanas/monitorcampanas.component';
import { DiarioComponent } from './supervisor/diario/diario.component';
import { HorasComponent } from './supervisor/horas/horas.component';
import { AgentecampanaComponent } from './supervisor/agentecampana/agentecampana.component';
import { CatalogocampanaComponent } from './supervisor/catalogocampana/catalogocampana.component';
import { LlamadaprogramadaComponent } from './supervisor/llamadaprogramada/llamadaprogramada.component';
import { DashboardpivotComponent } from './supervisor/dashboardpivot/dashboardpivot.component';
import { MonitoragentesComponent } from './supervisor/monitoragentes/monitoragentes.component';
import { ClienteDuplicadoComponent } from './home/cliente-duplicado/cliente-duplicado.component';
import { AutorizarCampanaComponent } from './home/autorizar-campana/autorizar-campana.component';
import { MensajeriaMasivaComponent } from './home/mensajeria-masiva/mensajeria-masiva.component';
import { ConfigBlacklistComponent } from './home/config-blacklist/config-blacklist.component';
import { AreaComponent } from './home/area/area.component';
import { AdministradorComponent } from './home/administrador/administrador.component';
import { ScheduleCitasComponent } from './home/schedule-citas/schedule-citas.component';
import { CampanaAdminComponent } from './home/campana-admin/campana-admin.component';
import { TipificacionRecolectorComponent } from './home/tipificacion-recolector/tipificacion-recolector.component';
import { EquipoRecolectadoComponent } from './home/equipo-recolectado/equipo-recolectado.component';
import { RecolectorEquiposComponent } from './home/recolector-equipos/recolector-equipos.component';
import { AdminAgenteComponent } from './home/admin-agente/admin-agente.component';
import { CitasProgramadasComponent } from './home/citas-programadas/citas-programadas.component';
import { CitasSuspendidasComponent } from './home/citas-suspendidas/citas-suspendidas.component';
import { ReporteCitaComponent } from './home/reporte-cita/reporte-cita.component';
import { ReporteFallapersisteComponent } from './home/reporte-fallapersiste/reporte-fallapersiste.component';
import { MapaCitaComponent } from './home/mapa-cita/mapa-cita.component';
import { SupervisorAdminComponent } from './home/supervisor-admin/supervisor-admin.component';
import { ConfigZonaComponent } from './home/config-zona/config-zona.component';
import { ConfigDistritoComponent } from './home/config-zona/config-distrito/config-distrito.component';
import { ConfigCorregimientoComponent } from './home/config-zona/config-corregimiento/config-corregimiento.component';
import { EdificioComponent } from './home/edificio/edificio.component';
import { MapaTecnicoComponent } from './home/mapa-tecnico/mapa-tecnico.component';
import { MonitoreoComponent } from './home/monitoreo/monitoreo.component';
import { ConfigAgenteComponent } from './home/config-zona/config-agente/config-agente.component';
import { RepoAlarmaInfructuosaComponent } from './home/repo-alarma-infructuosa/repo-alarma-infructuosa.component';
import { CruceSgoComponent } from './home/cruce-sgo/cruce-sgo.component';
import { ReporteZonaComponent } from './home/reporte-zona/reporte-zona.component';
import { ReportedispDistritoComponent } from './home/reporte-zona/reportedisp-distrito/reportedisp-distrito.component';
import { ReportedispCorregimientoComponent } from './home/reporte-zona/reportedisp-corregimiento/reportedisp-corregimiento.component';
import { ReportedispTecnicoComponent } from './home/reporte-zona/reportedisp-tecnico/reportedisp-tecnico.component';
import { ConsultaCertificadoNacimietoComponent } from './home/consulta-certificado-nacimieto/consulta-certificado-nacimieto.component';
import { HistorialcertificadoComponent } from './home/historialcertificado/historialcertificado.component';
import { FibProactivosComponent } from './home/fib-proactivos/fib-proactivos.component';
import { BitacoraProactivosComponent } from './home/bitacora-proactivos/bitacora-proactivos.component';
import { PxaComponent } from './home/pxa/pxa.component';
// ROLES -> 0: ADMIN, 1: AGENTE, 2: POSTVENTA, 3: SUPERVISOR
export const router: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'home', component: HomeComponent, canActivate: [AuthGuard, RoleGuard], data: { ROL: 0 },
    children: [
      { path: '', redirectTo: 'campana', pathMatch: 'full' },
      { path: 'campana', component: CampanaComponent },
      { path: 'campanaadmin', component: CampanaAdminComponent },
      { path: 'gestioncitas', component: ScheduleCitasComponent },
      { path: 'citasprogramadas', component: CitasProgramadasComponent },
      { path: 'citassuspendidas', component: CitasSuspendidasComponent },
      { path: 'mensajeria-masiva', component: MensajeriaMasivaComponent },
      { path: 'autorizacion', component: AutorizarCampanaComponent },
      { path: 'equiporecolectado', component: EquipoRecolectadoComponent },
      { path: 'recolectorequipos', component: RecolectorEquiposComponent },
      { path: 'clienteduplicado', component: ClienteDuplicadoComponent },
      { path: 'eje', component: EjeComponent },
      { path: 'tipologia', component: TipologiaComponent },
      { path: 'agendamiento', component: EntrevistaComponent },
      { path: 'tipificacionRecolector', component: TipificacionRecolectorComponent },
      { path: 'contrata', component: DistribuidorComponent },
      { path: 'rol', component: RolComponent },
      { path: 'area', component: AreaComponent },
      { path: 'administrador', component: AdministradorComponent },
      { path: 'agente', component: AgenteComponent },
      { path: 'adminagente', component: AdminAgenteComponent },
      { path: 'asignarCampana', component: AsignarCampanaComponent },
      { path: 'razonalarma', component: RazonAlarmaComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'configblacklist', component: ConfigBlacklistComponent },
      { path: 'monitorcampana', component: MonitorcampanasComponent },
      { path: 'catalogocampana', component: CatalogocampanaComponent },
      { path: 'diariocampana', component: DiarioComponent },
      { path: 'horascampana', component: HorasComponent },
      { path: 'agentescampana', component: AgentecampanaComponent },
      { path: 'rellamadacampana', component: LlamadaprogramadaComponent },
      { path: 'dashboardpivot', component: DashboardpivotComponent },
      { path: 'monitoragente', component: MonitoragentesComponent },
      { path: 'reportecitacanceladas', component: ReporteCitaComponent },
      { path: 'repoalarmainfructuosa', component: RepoAlarmaInfructuosaComponent },
      { path: 'crucesgo', component: CruceSgoComponent },
      { path: 'reportefallaspersistentes', component: ReporteFallapersisteComponent },
      { path: 'mapacitas', component: MapaCitaComponent },
      { path: 'supervisoradmin', component: SupervisorAdminComponent },
      { path: 'configprovincia', component: ConfigZonaComponent },
      { path: 'configdistrito', component: ConfigDistritoComponent },
      { path: 'configcorregimiento', component: ConfigCorregimientoComponent },
      { path: 'configagente', component: ConfigAgenteComponent },
      { path: 'edificio', component: EdificioComponent },
      { path: 'mapatecnicos', component: MapaTecnicoComponent },
      { path: 'monitoreo', component: MonitoreoComponent },
      { path: 'consultarcertificado', component: ConsultaCertificadoNacimietoComponent },
      { path: 'historialcertificado', component: HistorialcertificadoComponent },
      { path: 'fibproactivos', component: FibProactivosComponent },
      { path: 'bitacoraproactivos', component: BitacoraProactivosComponent },
      { path: 'pxa', component: PxaComponent },
      // REPORTES
      { path: 'reportedispprovincia', component: ReporteZonaComponent},
      { path: 'reportedispdistrito', component: ReportedispDistritoComponent},
      { path: 'reportedispcorregimiento', component: ReportedispCorregimientoComponent},
      { path: 'reportedisptecnico', component: ReportedispTecnicoComponent}
    ]
  },
  // Lazy loaded modules (Angular 6 string syntax)
  { path: 'login', loadChildren: './login/login.module#LoginModule' },
  { path: 'forgot', redirectTo: 'login/forgot', pathMatch: 'full' },
  {
    path: 'homeagente',
    loadChildren: './home-agente/home-agente.module#HomeAgenteModule',
    canActivate: [AuthGuard, RoleGuard],
    data: { ROL: 1 }
  },
  {
    path: 'postventa',
    loadChildren: './postventa/postventa.module#PostventaModule',
    canActivate: [AuthGuard, RoleGuard],
    data: { ROL: 2 }
  },
  // Supervisor stays eagerly loaded (components shared with /home routes)
  {
    path: 'supervisor', component: SupervisorComponent, canActivate: [AuthGuard, RoleGuard], data: { ROL: 3 },
    children: [
      { path: '', redirectTo: 'monitorcampana', pathMatch: 'full' },
      { path: 'monitorcampana', component: MonitorcampanasComponent },
      { path: 'catalogocampana', component: CatalogocampanaComponent },
      { path: 'diariocampana', component: DiarioComponent },
      { path: 'horascampana', component: HorasComponent },
      { path: 'agentescampana', component: AgentecampanaComponent },
      { path: 'rellamadacampana', component: LlamadaprogramadaComponent },
      { path: 'dashboardpivot', component: DashboardpivotComponent },
      { path: 'monitoragente', component: MonitoragentesComponent }
    ]
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);
